import { render, staticRenderFns } from "./MetaData.vue?vue&type=template&id=c0d01316&scoped=true&lang=pug&"
import script from "./MetaData.vue?vue&type=script&lang=js&"
export * from "./MetaData.vue?vue&type=script&lang=js&"
import style0 from "./MetaData.vue?vue&type=style&index=0&id=c0d01316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d01316",
  null
  
)

export default component.exports